import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import itAdmin from "./locales/it/admin.json";
import enAdmin from "./locales/en/admin.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      it: { admin: itAdmin },
      en: { admin: enAdmin },
    },
    lng: "it",
    fallbackLng: "it",
    defaultNS: "admin",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
